// extracted by mini-css-extract-plugin
export var foot = "styles-module__foot___uPA_r";
export var sliderContainer = "styles-module__sliderContainer___o7YTu";